export default "__VITE_ASSET__79dd161f__"